(function () {
  const BRANDING_SELECTORS = [
    '.k-popup__powered-by',
    '.k-popup__powered-by--storefront-logo',
    '.k-popup__powered-by-logo',
    '[class*="k-popup__powered-by"]',
  ].join(', ');

  const HIDE_CSS =
    BRANDING_SELECTORS +
    ' { display: none !important; visibility: hidden !important; height: 0 !important; max-height: 0 !important; overflow: hidden !important; opacity: 0 !important; pointer-events: none !important; }';

  function injectHideStyle(root) {
    if (!root || root.querySelector('[data-kaktus-branding-hide]')) return;

    const style = document.createElement('style');
    style.setAttribute('data-kaktus-branding-hide', '');
    style.textContent = HIDE_CSS;
    root.appendChild(style);
  }

  function hideBrandingInRoot(root) {
    if (!root || !root.querySelectorAll) return;

    root.querySelectorAll(BRANDING_SELECTORS).forEach((el) => {
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.remove();
    });
  }

  function processShadowRoot(shadowRoot) {
    if (!shadowRoot) return;

    injectHideStyle(shadowRoot);
    hideBrandingInRoot(shadowRoot);

    shadowRoot.querySelectorAll('*').forEach((el) => {
      if (el.shadowRoot) processShadowRoot(el.shadowRoot);
    });
  }

  function processNode(node) {
    if (!(node instanceof Element)) return;

    hideBrandingInRoot(node);

    if (node.shadowRoot) processShadowRoot(node.shadowRoot);

    node.querySelectorAll('*').forEach((el) => {
      if (el.shadowRoot) processShadowRoot(el.shadowRoot);
    });
  }

  function hideKaktusBranding() {
    hideBrandingInRoot(document);
    document.querySelectorAll('*').forEach((el) => {
      if (el.shadowRoot) processShadowRoot(el.shadowRoot);
    });
  }

  function handleMutations(mutations) {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => processNode(node));
    });
    hideKaktusBranding();
  }

  hideKaktusBranding();

  if (document.body) {
    new MutationObserver(handleMutations).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  document.addEventListener('DOMContentLoaded', hideKaktusBranding);
  window.addEventListener('load', hideKaktusBranding);
  [500, 1000, 2000, 5000].forEach((delay) => window.setTimeout(hideKaktusBranding, delay));
})();
